module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_20.png?73a4c0faec6c2e547b7082eda619f65f";